import './Group-436842dc.css';

var groupClasses = {"Group":"prc-ActionList-Group-fXpF9","GroupHeadingWrap":"prc-ActionList-GroupHeadingWrap-pfbd9","GroupHeading":"prc-ActionList-GroupHeading-eahp0"};

export { groupClasses as default };
